import { Pipe, PipeTransform } from '@angular/core';
import { PriceComponentResponse } from '../../../core/clients/omni-core/models';

@Pipe({
  name: 'priceReferenceUnit',
})
export class SupplierContractPriceReferenceUnitPipe implements PipeTransform {
  transform(value: PriceComponentResponse['referenceUnit']): string {
    switch (value) {
      case 'KWH':
        return 'cockpit.supplierContracts.units.referenceUnit.KWH';
      case 'MWH':
        return 'cockpit.supplierContracts.units.referenceUnit.MWH';
      case 'GWH':
        return 'cockpit.supplierContracts.units.referenceUnit.GWH';
      case 'KW':
        return 'cockpit.supplierContracts.units.referenceUnit.KW';
      case 'MW':
        return 'cockpit.supplierContracts.units.referenceUnit.MW';
      case 'DAY':
        return 'cockpit.supplierContracts.units.referenceUnit.DAY';
      case 'MONTH':
        return 'cockpit.supplierContracts.units.referenceUnit.MONTH';
      case 'YEAR':
        return 'cockpit.supplierContracts.units.referenceUnit.YEAR';
      default:
        return value;
    }
  }
}
